export default "__VITE_ASSET__Cvw85KvE__"